function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _mask, _path, _path2, _circle, _circle2, _circle3, _rect2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgStartFromScratch = function SvgStartFromScratch(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 168,
    fill: "none",
    viewBox: "0 0 137 168"
  }, props), {}, {
    children: [_rect || (_rect = /*#__PURE__*/_jsx("rect", {
      width: 136,
      height: 167,
      x: 0.5,
      y: 0.5,
      stroke: "#E6E6E6",
      rx: 5.5
    })), _mask || (_mask = /*#__PURE__*/_jsx("mask", {
      id: "a",
      fill: "#fff",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 6a6 6 0 0 1 6-6h125a6 6 0 0 1 6 6v18H0z"
      })
    })), _path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "#E6E6E6",
      fillOpacity: 0.3,
      d: "M0 6a6 6 0 0 1 6-6h125a6 6 0 0 1 6 6v18H0z"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fill: "#E6E6E6",
      d: "M0 0h137zm137 25H0v-2h137zM0 24V0zM137 0v24z",
      mask: "url(#a)"
    })), _circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: 14.5,
      cy: 12,
      r: 2.5,
      fill: "#E6E6E6"
    })), _circle2 || (_circle2 = /*#__PURE__*/_jsx("circle", {
      cx: 23.5,
      cy: 12,
      r: 2.5,
      fill: "#E6E6E6"
    })), _circle3 || (_circle3 = /*#__PURE__*/_jsx("circle", {
      cx: 32.5,
      cy: 12,
      r: 2.5,
      fill: "#E6E6E6"
    })), _rect2 || (_rect2 = /*#__PURE__*/_jsx("rect", {
      width: 36,
      height: 5,
      x: 89,
      y: 9.5,
      fill: "#E6E6E6",
      rx: 2.5
    })), _rect3 || (_rect3 = /*#__PURE__*/_jsx("rect", {
      width: 112,
      height: 51,
      x: 12.5,
      y: 35.5,
      stroke: "#E6E6E6",
      strokeDasharray: "4 4",
      rx: 4.5
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fill: "#E6E6E6",
      d: "M57.333 76a3.2 3.2 0 0 1-2.354-.98A3.2 3.2 0 0 1 54 72.668V49.333q0-1.374.98-2.354A3.2 3.2 0 0 1 57.332 46h23.334a3.2 3.2 0 0 1 2.354.98A3.2 3.2 0 0 1 84 49.332v23.334a3.2 3.2 0 0 1-.98 2.354 3.2 3.2 0 0 1-2.353.979zm0-3.333h23.334V49.333H57.333zM59 69.333h20L72.75 61l-5 6.667-3.75-5zm5.938-12.395q.729-.73.729-1.771 0-1.042-.73-1.771a2.4 2.4 0 0 0-1.77-.73 2.4 2.4 0 0 0-1.771.73 2.4 2.4 0 0 0-.73 1.77q0 1.042.73 1.772.729.729 1.77.729 1.042 0 1.772-.73"
    })), _rect4 || (_rect4 = /*#__PURE__*/_jsx("rect", {
      width: 90,
      height: 4,
      x: 12,
      y: 101,
      fill: "#E6E6E6",
      rx: 2
    })), _rect5 || (_rect5 = /*#__PURE__*/_jsx("rect", {
      width: 62,
      height: 4,
      x: 12,
      y: 111,
      fill: "#E6E6E6",
      rx: 2
    })), _rect6 || (_rect6 = /*#__PURE__*/_jsx("rect", {
      width: 54,
      height: 22,
      x: 12,
      y: 123,
      fill: "#E6E6E6",
      rx: 2
    })), _rect7 || (_rect7 = /*#__PURE__*/_jsx("rect", {
      width: 54,
      height: 22,
      x: 72,
      y: 123,
      fill: "#E6E6E6",
      rx: 2
    })), _rect8 || (_rect8 = /*#__PURE__*/_jsx("rect", {
      width: 93,
      height: 4,
      x: 12,
      y: 153,
      fill: "#E6E6E6",
      rx: 2
    }))]
  }));
};
export default SvgStartFromScratch;